import { render, staticRenderFns } from "./registerbusiness.vue?vue&type=template&id=1bcf65d4&scoped=true"
import script from "./registerbusiness.vue?vue&type=script&lang=js"
export * from "./registerbusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf65d4",
  null
  
)

export default component.exports